<template>
  <div class="row mt-5">
    <loading v-if="loadingRender"></loading>
    <div class="col-md-2 col-12"></div>
    <div class="col-md-8 col-12">
      <div v-if="!Status" class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
        <div class="alert text-center bg-danger-custom w-100">
          <i class="fas fa-times-circle text-danger" style="font-size: 17px !important"></i>
          <span class="text-dark" style="font-size: 17px !important">{{ TextVazeiat }}</span>

          <!-- <i v-if="IsBtnBack==true" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-warning Pointer" style="float:left;font-size:18px;" @click="Back"></i>
                        <i v-if="IsBtnClose==true" title="بازگشت به صفحه قبلی" class="fas fa-times text-warning Pointer" style="float:left;font-size:18px;" data-dismiss="modal"></i> -->
        </div>
        <span class="text-dark text-center" style="font-size: 17px !important">تاریخ : {{ Tarix }}</span>
        <span class="text-dark text-center mt-3" style="font-size: 17px !important">نام درگاه :{{ NameDargah }}</span>
        <span class="text-dark text-center mt-3" style="font-size: 17px !important">کد رهگیری : {{ CodeRahgiri }}</span>
        <span v-if="linkpay" class="text-dark text-center mt-3" style="font-size: 17px !important"> مشخصات پرداخت کننده
          : {{ NameFamily }}</span>
        <span v-if="linkpay" class="text-dark text-center mt-3" style="font-size: 17px !important"> مبلغ پرداختی : {{
          $Comma3ragham(MablaghPardakhti) }}</span>
        <button type="button"
          v-if="$session.get('TokenNetPa') != undefined && $session.get('TokenHampa') == undefined && !linkpay"
          class="btn btn-danger mr-1 mt-3 no-print" dir="ltr" @click="GoToDashboard()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به سامانه</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button type="button"
          v-if="$session.get('TokenNetPa') == undefined && $session.get('TokenHampa') == undefined && !linkpay"
          class="btn btn-danger mr-1 mt-3 no-print" dir="ltr" @click="GoToLogin()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به صفحه اصلی</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="detectedOS == 'Android' && $session.get('TokenHampa') != undefined && !linkpay" type="button"
          class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoHampa()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به همراه بانک</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="$session.get('TokenVgate') != undefined && linkpay" type="button"
          class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoVgate()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به پیشخوان مجازی</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="$session.get('TokenVgate') == undefined && linkpay" type="button"
          class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoLink()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به لینک پرداخت</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="Status" class="btn btn-warning mr-1 mt-3 no-print" type="button" @click="PrintPage"><span
            class="mr-2" style="font-size: 17px !important">چاپ رسید</span></button>
      </div>
      <div v-else class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
        <div class="alert text-center bg-success-custom w-100">
          <i class="fas fa-times-circle text-success" style="font-size: 17px !important"></i>
          <span class="text-dark" style="font-size: 17px !important">{{ TextVazeiat }}</span>
          <br />
          <span class="text-dark" style="font-size: 15px !important"
            v-if="detectedOS == 'Android' && $session.get('TokenHampa') != undefined"> پرداخت شما با موفقیت انجام شد
          </span>
          <span v-else class="text-dark" style="font-size: 14px !important"> پرداخت شما با موفقیت انجام شد برای مشاهده
            وضعیت واریز ها از منوی "سایر > گزارش پرداخت اینترنتی" وضعیت واریز را دنبال کنید. </span>
          <!-- <i v-if="IsBtnBack==true" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-warning Pointer" style="float:left;font-size:18px;" @click="Back"></i>
                        <i v-if="IsBtnClose==true" title="بازگشت به صفحه قبلی" class="fas fa-times text-warning Pointer" style="float:left;font-size:18px;" data-dismiss="modal"></i> -->
        </div>
        <span class="text-dark text-center" style="font-size: 17px !important">تاریخ : {{ Tarix }}</span>
        <span class="text-dark text-center mt-3" style="font-size: 17px !important">نام درگاه :{{ NameDargah }}</span>
        <span class="text-dark text-center mt-3" style="font-size: 17px !important">کد رهگیری : {{ CodeRahgiri }}</span>
        <span v-if="linkpay" class="text-dark text-center mt-3" style="font-size: 17px !important"> مشخصات پرداخت کننده
          : {{ NameFamily }}</span>
        <span class="text-dark text-center mt-3" style="font-size: 17px !important"> مبلغ پرداختی : {{
          $Comma3ragham(MablaghPardakhti) }}</span>
        <button v-if="$session.get('TokenNetPa') != undefined && $session.get('TokenHampa') == undefined && !linkpay"
          type="button" class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoToDashboard()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به اینترنت بانک</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="$session.get('TokenNetPa') == undefined && $session.get('TokenHampa') == undefined && !linkpay"
          type="button" class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoToLogin()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به صفحه اصلی</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="$session.get('TokenVgate') != undefined && linkpay" type="button"
          class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoVgate()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به پیشخوان مجازی</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="$session.get('TokenVgate') == undefined && linkpay" type="button"
          class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoLink()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به لینک پرداخت</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="detectedOS == 'Android' && $session.get('TokenHampa') != undefined && !linkpay" type="button"
          class="btn btn-success mr-1 mt-3 no-print" dir="ltr" @click="GoHampa()">
          <span class="mr-2" style="font-size: 17px !important"> بازگشت به همراه بانک</span>
          <span class="fa fa-arrow-left"></span>
        </button>
        <button v-if="Status" class="btn btn-warning mr-1 mt-3 no-print" type="button" @click="PrintPage"><span
            class="mr-2" style="font-size: 17px !important">چاپ رسید</span></button>
      </div>
    </div>
    <div class="col-md-2 col-12"></div>
  </div>
</template>
<script>
import loading from '../Tools/NetPa/Loading.vue'
export default {
  components: {
    loading,
  },
  data() {
    return {
      DataAxios: {
        ArryfildValue: '',
        Method: 'Post',
        Action: '',
        Token: this.$session.get('TokenNetPa'),
      },
      TextVazeiat: '',
      Status: false,
      CodeRahgiri: '',
      Tarix: '',
      loadingRender: false,
      detectedOS: null,
      NameDargah: '',
      MablaghPardakhti: '',
      NameFamily: '',
      linkpay: false,
    }
  },
  mounted() {
    try {
      this.detectedOS = this.$OsName()
      if (this.$route.params.Status == 'Verify_Parsian') {
        data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data)
        // console.log('data', data)
        this.NameDargah = 'پارسیان'

        this.loadingRender = true
        const formData = new FormData()
        formData.append('isSuccess', data.isSuccess)
        formData.append('orderId', data.orderId)
        formData.append('trakingCode', data.trakingCode)
        this.DataAxios.ArryfildValue = formData
        this.DataAxios.Action = 'Verify/Verify_Parsian'
        this.$PostFormData(this.DataAxios).then((data) => {
          // console.log('8', data)
          if (data.success) {
            if (data.linkpay != undefined && data.linkpay) {
              this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
              this.CodeRahgiri = data.coderahgiri
              this.Tarix = data.tarix
              this.Status = true
              this.loadingRender = false
              this.NameFamily = data.name
              this.MablaghPardakhti = data.mablagh
              this.linkpay = true
            } else {
              this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
              this.CodeRahgiri = data.coderahgiri
              this.Tarix = data.tarix
              this.Status = true
              this.loadingRender = false
              this.MablaghPardakhti = data.mablagh
            }
          } else {
            this.TextVazeiat = data.txt
            this.CodeRahgiri = data.trakingCode
            this.Tarix = '---'
            this.Status = false
            this.loadingRender = false
          }
        })
      }
      if (this.$route.params.Status == 'Verify_ZarinPal') {
        this.NameDargah = 'زرین پال'
        if (this.$route.query.Status == 'OK') {
          this.loadingRender = true
          const formData = new FormData()
          formData.append('Status', this.$route.query.Status)
          formData.append('authority', this.$route.query.Authority)
          this.DataAxios.ArryfildValue = formData
          this.DataAxios.Action = 'Verify/Verify_ZarinPal'
          this.$PostFormData(this.DataAxios).then((data) => {
            if (data.success) {
              if (data.linkpay != undefined && data.linkpay) {
                this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
                this.CodeRahgiri = data.coderahgiri
                this.Tarix = data.tarix
                this.Status = true
                this.loadingRender = false
                this.NameFamily = data.name
                this.MablaghPardakhti = data.mablagh
                this.linkpay = true
              } else {
                this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
                this.CodeRahgiri = data.coderahgiri
                this.Tarix = data.tarix
                this.Status = true
                this.loadingRender = false
                this.MablaghPardakhti = data.mablagh
              }
            } else {
              this.loadingRender = false
            }
          })
        } else {
          this.TextVazeiat = ' انصراف از پرداخت '
          this.CodeRahgiri = '---'
          this.Tarix = '---'
          this.loadingRender = false
        }
      }
      if (this.$route.params.Status == 'Verify_ZarinPalDirect') {
        this.NameDargah = 'زرین پال'
        if (this.$route.query.Status == 'OK') {
          this.loadingRender = true
          const formData = new FormData()
          formData.append('Status', this.$route.query.Status)
          formData.append('authority', this.$route.query.Authority)
          this.DataAxios.ArryfildValue = formData
          this.DataAxios.Action = 'Verify/Verify_ZarinPalDirect'
          this.$PostFormData(this.DataAxios).then((data) => {
            if (data.success) {
              this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
              this.CodeRahgiri = data.coderahgiri
              this.Tarix = data.tarix
              this.Status = true
              this.loadingRender = false
              //this.MablaghPardakhti = data.mablagh
            } else {
              this.loadingRender = false
            }
          })
        } else {
          this.TextVazeiat = ' انصراف از پرداخت '
          this.CodeRahgiri = '---'
          this.Tarix = '---'
          this.loadingRender = false
        }
      }
      if (this.$route.params.Status == 'Verify_SadadMeli') {
        this.NameDargah = ' درگاه سداد بانک ملی'
        this.loadingRender = true
        var data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        if (data.success) {
          this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = true
          this.loadingRender = false
          //this.MablaghPardakhti = data.mablagh
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }
      if (this.$route.params.Status == 'Verify_MellatBnp') {
        this.NameDargah = 'درگاه به پرداخت بانک ملت ( شرکت پاسارگاد) '
        this.loadingRender = true
        data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        // console.log(data)
        if (data.success) {
          if (data.linkpay != undefined && data.linkpay) {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            this.NameFamily = data.name
            this.MablaghPardakhti = data.mablagh
            this.linkpay = true
          } else {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            this.MablaghPardakhti = data.mablagh
          }
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }
      if (this.$route.params.Status == 'Verify_SamanKishBnp') {
        this.NameDargah = 'درگاه سامان کیش  '
        this.loadingRender = true
        data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        if (data.success) {
          this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = true
          this.loadingRender = false
          //this.MablaghPardakhti = data.mablagh
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }
      if (this.$route.params.Status == 'Verify_SamanKishBnp932') {
        this.NameDargah = 'درگاه سامان کیش  '
        this.loadingRender = true
        data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        if (data.success) {
          this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = true
          this.loadingRender = false
          //this.MablaghPardakhti = data.mablagh
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }
      if (this.$route.params.Status == 'Verify_BehPardakht') {
        this.NameDargah = ' درگاه به پرداخت ملت'
        this.loadingRender = true
        var data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        if (data.success) {
          this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = true
          this.loadingRender = false
          this.MablaghPardakhti = data.mablagh
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }

      if (this.$route.params.Status == 'Verify_Alsat') {
        this.NameDargah = 'درگاه پرداخت آلسات '
        this.loadingRender = true

        data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        // console.log(data)
        if (data.success) {
          if (data.linkpay != undefined && data.linkpay == true) {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            this.NameFamily = data.name
            this.MablaghPardakhti = data.mablagh
            this.linkpay = true
          } else {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            //this.MablaghPardakhti = data.mablagh
          }
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }
      if (this.$route.params.Status == 'Verify_Shepa') {
        this.NameDargah = 'درگاه پرداخت شپا '
        this.loadingRender = true

        data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        if (data.success) {
          if (data.linkpay != undefined && data.linkpay == true) {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            this.NameFamily = data.name
            this.MablaghPardakhti = data.mablagh
            this.linkpay = true
          } else {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            //this.MablaghPardakhti = data.mablagh
          }
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }
      if (this.$route.params.Status == 'Verify_PayStar') {
        this.NameDargah = 'درگاه پرداخت پی استار'
        this.loadingRender = true
        data = this.$route.query
        data = decodeURI(data.encver)
        data = this.$DecryptionWithCryptoJS(data)
        data = JSON.parse(data.replace(/'/g, '"'))
        if (data.success == 'True') {
          if (data.linkpay != undefined && data.linkpay == true) {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            this.NameFamily = data.name
            this.MablaghPardakhti = data.mablagh
            this.linkpay = true
          } else {
            this.TextVazeiat = ' تراکنش با موفقیت انجام شد '
            this.CodeRahgiri = data.coderahgiri
            this.Tarix = data.tarix
            this.Status = true
            this.loadingRender = false
            //this.MablaghPardakhti = data.mablagh
          }
        } else {
          this.TextVazeiat = data.txt
          this.CodeRahgiri = data.coderahgiri
          this.Tarix = data.tarix
          this.Status = false
          this.loadingRender = false
        }
        // })
      }
    } catch (error) {
      this.loadingRender = false
    }
  },
  methods: {
    PrintPage: function () {
      window.print()
    },
    GoToDashboard() {
      this.$router.push('/PishkhanNetPa/OnlinePaymentReport')
    },
    GoToLogin() {
      this.$router.push('/')
    },
    GoHampa() {
      //location.href = 'bnphampa://paymentresult/?status=1'
      location.href = 'HampaPlus://bnpco.ir/home'
    },
    GoVgate() {
      location.href = 'bnpvgate://paymentresult/?status=1'
    },
    GoLink() {
      // console.log(this.$session.get('likpay'));

      location.href = this.$session.get('likpay')
    }
  },
  created() { },
}
</script>

<style scoped>
.bg-danger-custom {
  border: 2px solid #fc0000 !important;
  transition: 0.3s;
}

.bg-success-custom {
  border: 2px solid #67b221 !important;
  transition: 0.3s;
}

@media print {
  .no-print {
    display: none;
  }
}
</style>
